module.exports = "<div class=\"container section-container\">\n        <div class=\"content\">\n            <div class=\"block panel-body\">\n                <h3>Ваш билет на трамвай</h3>\n                <div class=\"ticket-display\">\n                    <ticket-display [ticketId]=\"ticketId\"></ticket-display>\n                </div>\n            <div>\n        </div>\n    </div>"


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/ticket.component.html
// module id = ../../../../../src/app/pages/ticket.component.html
// module chunks = main